export const createClientVisitor = (
  visitorId = null,
  authenticated,
  deviceType,
  searchParams = '',
  pagePath = '/',
  offerCode = '',
) => {
  if (visitorId) visitorId += '';
  return {
    id: visitorId,
    context: {
      deviceType: String(deviceType),
      queryParameters: searchParams,
      pagePath: pagePath,
      offerCode: offerCode.toLowerCase(),
    },
    isAuthenticated: authenticated,
  };
};
